<template>
  <b-dropdown size="md" variant="link"
    toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon" no-caret right no-flip
    v-b-tooltip.hover.top="$t('TRANSLATOR.EDIT')">
    <template v-slot:button-content>
      <i class="flaticon2-settings"></i>
    </template>
    <!--begin::Navigation-->
    <div class="navi navi-hover min-w-md-350px p-3">
      <b-dropdown-text tag="div" class="navi-item my-3">
        <span class="navi-text">{{ $t("TRANSLATOR.EDIT") }} <b>{{ sparePart }}</b> {{ $t('TRANSLATOR.NOW_ITS') }} {{ currentStatus }}</span>
        <!-- now it's {{ newstatus }}<br />
            Current status is : {{ currentStatus }}</span> -->
        <!-- </a> -->
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-separator my-3"></b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item my-3">
        <textarea ref="note" class="form-control form-control-md form-control-solid" type="text" v-model="note" rows="2"
          :placeholder="$t('TRANSLATOR.ADD_EXTRA_NOTE_HERE')" />
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item my-3">
        <b-form-file v-model="file" :state="file" :placeholder="$t('TRANSLATOR.CHOOSEFILEDROP')"
          :drop-placeholder="$t('TRANSLATOR.CHOOSEFILEDROP')" accept="image/png,image/jpeg,image/jpg"></b-form-file>
        <span class="mt-3 text-danger" v-if="isImageSize == true"> File size exceeds 9 MB </span>
        <!-- <span class="mt-3 text-success" v-if="isImagesuccess == true"> Image uploaded! </span> -->
        <!-- <b-button
          type="submit"
          class="mt-3 w-100"
          variant="primary"
          size="md"
          @click="UploadImg"
          v-if="file"
          >Upload</b-button
        > -->
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-separator my-3"></b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item">
        <a class="navi-link" style="cursor: pointer" @click="SaveAllData('green')">
          <span class="navi-icon">
            <i class="flaticon2-check-mark text-success"></i>
          </span>
          <span :class="[currentStatus == 'green' ? 'navi-text label-light-primary' : 'navi-text']">{{ $t('TRANSLATOR.JUST_CHANGED') }}</span>
          <span class="navi-link-badge">
            <span class="label label-light-success label-inline font-weight-bold">
              {{ $t('TRANSLATOR.GREEN') }}
            </span>
          </span>
        </a>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item">
        <a class="navi-link" style="cursor: pointer" @click="SaveAllData('orange')">
          <span class="navi-icon">
            <i class="flaticon2-warning text-warning"></i>
          </span>
          <span :class="[currentStatus == 'orange' ? 'navi-text label-light-primary' : 'navi-text']">{{ $t('TRANSLATOR.BE_CAREFULL') }}</span>
          <span class="navi-link-badge">
            <span class="label label-light-warning label-inline font-weight-bold">
              {{ $t('TRANSLATOR.ORANGE') }}
            </span>
          </span>
        </a>
      </b-dropdown-text>
      <b-dropdown-text tag="div" class="navi-item">
        <a class="navi-link" style="cursor: pointer" @click="SaveAllData('red')">
          <span class="navi-icon">
            <i class="flaticon-cancel text-danger"></i>
          </span>
          <span :class="[currentStatus == 'red' ? 'navi-text label-light-primary' : 'navi-text']">{{ $t('TRANSLATOR.MUST_CHANGE') }}</span>
          <span class="navi-link-badge">
            <span class="label label-light-danger label-inline font-weight-bold">
              {{ $t('TRANSLATOR.RED') }}
            </span>
          </span>
        </a>
      </b-dropdown-text>
        <b-alert :show="dismissCountDown" dismissible fade variant="success" class="mt-5" @dismissed="dismissCountDown = 0">
          Status updated successfully
        </b-alert>
    </div>

    <!--end::Navigation-->
  </b-dropdown>
</template>

<style lang="scss">
.custom-v-dropdown {
  &.dropdown-toggle {
    padding: 0;

    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  &.dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;

    .b-dropdown-text {
      padding: 0;
    }
  }
}
</style>

<script>
import axios from "axios";

const dataURItoBlob = (dataURI) => {
  const bytes = dataURI.split(',')[0].indexOf('base64') >= 0
    ? atob(dataURI.split(',')[1])
    : unescape(dataURI.split(',')[1]);
  const mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const max = bytes.length;
  const ia = new Uint8Array(max);
  for (let i = 0; i < max; i += 1) ia[i] = bytes.charCodeAt(i);
  return new Blob([ia], { type: mime });
};

const resizeImage = ({ file, maxSize }) => {
  const reader = new FileReader();
  const image = new Image();
  const canvas = document.createElement('canvas');
 
  const resize = () => {
    let { width, height } = image;

    if (width > height) {
      if (width > maxSize) {
        height *= maxSize / width;
        width = maxSize;
      }
    } else if (height > maxSize) {
      width *= maxSize / height;
      height = maxSize;
    }

    canvas.width = width;
    canvas.height = height;
    canvas.getContext('2d').drawImage(image, 0, 0, width, height);

    const dataUrl = canvas.toDataURL('image/jpeg');
    return dataURItoBlob(dataUrl);
  };

  return new Promise((ok, no) => {
    if (!file.type.match(/image.*/)) {
      no(new Error('Not an image'));
      return;
    }

    reader.onload = (readerEvent) => {
      image.onload = () => ok(resize());
      image.src = readerEvent.target.result;
    };
    reader.readAsDataURL(file);
  });
};

export default {
  props: [
    "conveyorNumber",
    "companyId",
    "lineNumber",
    "sparePart",
    "currentStatus",
    "userId",
    "userEmail",
    "userName",
  ],
  name: "dropdown-3",
  data() {
  
    return {
      submitted: false,
      file: null,
      newstatus: this.currentStatus,
      oldStatus: this.currentStatus,
      note: null,
      dismissSecs: 5,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      isImageSize: false,
      isImagesuccess: false,
    };
  },
  components: {},
  mounted() {
  },
  methods: {
    // submit form handler
    submit: function (code) {
      this.oldStatus = this.currentStatus
      this.currentStatus = code
      this.newstatus = code;
      this.submitted = true;
      this.dismissCountDown = this.dismissSecs;
    },
    // countDownChanged(dismissCountDown) {
    //   this.dismissCountDown = dismissCountDown;
    // },
    SaveAllData: function(code) {
      this.oldStatus = this.currentStatus;
      this.currentStatus = code;
      this.newstatus = code;

        let formData = new FormData();

      if (this.file != null) {
        if (this.file.size >= '9242880') {
          this.isImageSize = true
          return;
        } else {
          this.isImageSize = false
        }
        // const FileName = "HeaderImage"
        const FileName = this.file.name.split(".").slice(0, -1).join(".")
        const photoUrl = URL.createObjectURL(this.file);
        const image = new Image();
        const imageDimensions = new Promise((resolve) => {
          image.onload = () => {
            const dimensions = {
              height: image.height,
              width: image.width,
            };
            resolve(dimensions);
          };
          image.src = photoUrl;
        });
        var extension = this.file.name.substr(this.file.name.lastIndexOf('.') + 1);
        if(extension == 'jpeg' || extension == 'png'){
          extension = 'jpg'
        }
        if (imageDimensions.width > 1000) {
          const ResizedImage = new Promise((resolve) => {
            resizeImage({ file: this.file, maxSize: 1000 }).then((resizedImage) => {
              this.url = URL.createObjectURL(resizedImage);
              const cfile = new File([resizedImage], FileName + "."+extension,
                { type: resizedImage.type, lastModified: Date.now() });
              resolve(cfile);
              return cfile;
            }).catch((err) => {
              throw err;
              // console.error(err);
            });
            });

          formData.append("file",  ResizedImage);
        } else {
          formData.append("file", this.file);
        }
        formData.append("FileName", FileName);
        formData.append("extension", extension);
      }
 
        formData.append("SparePart", this.sparePart);    
        formData.append("CompanyId", this.companyId);
        formData.append("LineNumber", this.lineNumber);
        formData.append("ConveyorNumber", this.conveyorNumber);
        formData.append("NewStatus", this.newstatus);
        formData.append("CurrentStatus", this.oldStatus);
        formData.append("UserId", this.userId);
        formData.append("Note", this.note);

        let config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
       
      var currentUrl = window.location.href;
      
      // Execute Update Conveyor Status
      axios
        .post("line/updateSparePartStatus", formData, config
        )
        .then(() => {
          this.submitted = true;
          this.dismissCountDown = this.dismissSecs;
          this.note = null;
          // Reload page with new status
          this.$emit("statusChange");
        })
        .catch((err) => {
          throw err;
        });

      let QuoteMessage = this.userName + " has changed the status from " + this.oldStatus + " to " + this.newstatus + " for Conveyor " + this.conveyorNumber + " " + this.sparePart + "<br /> <a href=" + currentUrl + ">Here</a> is the link for your conveyor page.";
      let QuoteSubject = "Status Changed: Factory " + this.companyId + " > " + "line " + this.lineNumber + " > conveyor " + this.conveyorNumber;
      if (this.newstatus == "red") {
        axios
          .post("line/sendLineEdit", {
            UserName: this.userName,
            UserEmail: this.userEmail,
            CompanyId: this.companyId,
            LineNumber: this.lineNumber,
            ConveyorNumber: this.conveyorNumber,
            NewStatus: this.newstatus,
            SparePart: this.sparePart,
            CurrentStatus: this.oldStatus,
            UserId: this.userId,
            QuoteMessage: QuoteMessage,
            QuoteSubject: QuoteSubject,
          })
          .then(() => { })
          .catch((err) => {
            throw err;
          });
      }
    },
    fetchLineHistory() {
      axios.get("line/" + this.lineNumber + "/conveyor/" + this.conveyorNumber + "/history")
        .then((response) => {
          this.lineHistory = response.data;
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
</script>
